import { cn } from "@omni/utils/styles";

import { DamImage } from "@/utils/dam.utils";

import { SearchItem, SearchItemType } from "../../storeSearchInput.types";

type SearchItemProps = SearchItem & {
    highlight: boolean;
};

const SearchItemComponent = ({
    label,
    type,
    value,
    highlight
}: SearchItemProps) => {
    if (!label) {
        return null;
    }

    return (
        <div
            key={value}
            className={cn("tw:flex tw:items-center")}
        >
            {type === SearchItemType.Locality && (
                <i className={cn("las la-map-marker mr-1")}></i>
            )}
            {type === SearchItemType.Store && (
                // biome-ignore lint/a11y/useAltText: <TODO>
                <img
                    src={DamImage.icon.maps.icon}
                    width="16"
                    height="16"
                    className={cn("tw:mr-1 tw:w-4 tw:h-4")}
                />
            )}
            <span
                className={cn("tw:line-clamp-1 tw:wrap-anywhere", {
                    "tw:has-[span]:font-bold tw:[&>span]:font-normal": highlight
                })}
                dangerouslySetInnerHTML={{ __html: label }}
            />
        </div>
    );
};

export { SearchItemComponent };
